import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  useEffect(() => {
    // Skip the auth probe for anonymous visitors on public marketing pages so we
    // don't emit cosmetic 401s in the console. Logged-in users keep a bearer token.
    const token = localStorage.getItem("espresso_token");
    const p = typeof window !== "undefined" ? window.location.pathname : "";
    const publicPath =
      p === "/" ||
      p.startsWith("/login") ||
      p.startsWith("/register") ||
      p.startsWith("/use-cases") ||
      p.startsWith("/showcase") ||
      p.startsWith("/pricing");
    if (!token && publicPath) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { formatApiErrorDetail };
